import React, { useState } from "react";
import { useSelector } from "react-redux";
import { ApplicationState } from "../../store";
import { DialogComponent } from "../common/DialogComponent";
import TermsAndConditionReAcceptanceDialog from "../Dialogs/TermsAndConditionReAcceptanceDialog";

const TermsAndConditionsReacceptance = (props: any) => {
    const isTermsAndConditionUpdated = useSelector((state: ApplicationState) => {
        return state.loggedInUser &&
            state.loggedInUser.termsAndConditionsReacceptance &&
            state.loggedInUser.termsAndConditionsReacceptance.isTermsAndConditionUpdated
            ? true
            : false;
    });

    const termsAndCondition = useSelector((state: ApplicationState) => {
        return state.loggedInUser && state.loggedInUser.termsAndConditionsReacceptance && state.loggedInUser.termsAndConditionsReacceptance.termsAndConditions
            ? state.loggedInUser.termsAndConditionsReacceptance.termsAndConditions
            : "";
    });

    const [isTandCReacceptanceDialogVisible, setTandCReacceptanceDialogVisible] = useState(isTermsAndConditionUpdated);
    const closeTermsAndConditionDialog = (): any => {
        setTandCReacceptanceDialogVisible(false);
    };

    return (
        <React.Fragment>
            {isTandCReacceptanceDialogVisible && (
                <DialogComponent
                    hideCloseButton={true}
                    dialogId="dialog-terms-and-condition-re-acceptance"
                    title="Add Family Member"
                    closeDialog={closeTermsAndConditionDialog}
                >
                    <TermsAndConditionReAcceptanceDialog
                        termsANDCondition={termsAndCondition}
                        closeDialog={closeTermsAndConditionDialog}
                        dialogId="dialog-terms-and-condition-re-acceptance"
                    />
                </DialogComponent>
            )}
        </React.Fragment>
    );
};

export default TermsAndConditionsReacceptance;
